import { connect } from 'react-redux';

import SensorSamplesReportDialog from '../../components/SensorSamplesReport/SensorSamplesReportDialog';
import { closeSensorSamplesReport, fetchSensorSamples } from '../../actions/SensorsSamplesActions';
import { acousticSensorOptions } from '../../utils/acousticSensors';

const mapStateToProps = (state) => {
  const selectedProject = state.leaksList.selectedProject;
  const projectState = state.leaksList.leaksByProject[selectedProject];
  const sensors = (projectState && projectState.sensors && projectState.sensors.sensors) || [];

  return {
    open: state.sensorSamplesReport.open,
    initialSensorIds: state.sensorSamplesReport.initialSensorIds,
    projectId: selectedProject,
    timeZone: state.local.timeZone,
    projectTimezone: projectState && projectState.projectDetails && projectState.projectDetails.time_zone,
    sensorOptions: acousticSensorOptions(sensors),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closeSensorSamplesReport()),
  fetchSensorSamples: (projectId, sensorIds, from, to) =>
    dispatch(fetchSensorSamples(projectId, sensorIds, from, to)),
});

const CSensorSamplesReportDialog = connect(
  mapStateToProps,
  mapDispatchToProps
)(SensorSamplesReportDialog);

export default CSensorSamplesReportDialog;
